import HistorySolutionModal from './history-solution-modal'

export default HistorySolutionModal
